export const ROOT_ELEMENT_ID = 'app';

export const SKILLAREA_TITLE = 'Skillarea';

export const SKILLAREA_COMPANY_NAME = 'Quantum LLC';
export const SKILLAREA_LEGAL_ADDRESS =
  "Georgia, Tbilisi, Nadzaladevi district, Zghvisubani settlement, XI micro/district, II quarter, building 38', apartment 7";

export const EMAIL_SYMBOLS_REGEX = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.@-]+$/;

export const LANG_PROP_NAME = 'lang';

export const UTM_PROP_NAME = 'UTM';

export const SUBSCRIPTION_PAYMENT_RETRIES = 3;

// HEARTBEAT_EVENT and HEARTBEAT_INTERVAL are exported from SSE module
export const IS_LOGGED_COOKIE_NAME = 'is_logged';
export const BLOCKED_ACCOUNT_COOKIE_NAME = 'blockedAccount';
export const TEMP_ID_COOKIE_NAME = 'temp_id';

// MFA cookies
export const MFA_TOKEN_COOKIE_NAME = 'mfaToken';
export const MFA_PENDING_COOKIE_NAME = 'is_mfa_pending';
export const PICK_RETURN_TIME_FIELDS = ['updatedAt', 'deletedAt'] as const;

export const OMIT_RETURN_TIME_FIELDS = ['createdAt'] as const;

export const OMIT_UPSERT_FIELDS = ['id', 'updatedAt', 'deletedAt'] as const;

export const IMAGE_EXTENSION = [
  'apng',
  'png',
  'avif',
  'gif',
  'jpg',
  'jpeg',
  'jfif',
  'pjpeg',
  'pjp',
  'svg',
  'webp',
];

// CryptoCloud USDT network codes (v1)
export const CRYPTOCLOUD_USDT_NETWORKS = [
  'USDT_ARB',
  'USDT_BSC',
  'USDT_ERC20',
  'USDT_OPT',
  'USDT_SOL',
  'USDT_TON',
  'USDT_TRC20',
] as const;

export type TCryptocloudUsdtNetwork =
  (typeof CRYPTOCLOUD_USDT_NETWORKS)[number];
